export default "__VITE_ASSET__Bmh_sDxu__"